import React from "react";
import './Footer.scss'

const Footer = () => <footer className="c-site-footer"></footer>

export default Footer;